import React from 'react';

const GamePoker = ({ style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM4.2373 17.4727C5.82197 19.7163 8.35238 21.2414 11.25 21.4678V18.959C9.26637 18.7477 7.53021 17.709 6.39453 16.1934L4.2373 17.4727ZM17.6045 16.1934C16.4688 17.7088 14.7334 18.7477 12.75 18.959V21.4678C15.6474 21.2414 18.177 19.7161 19.7617 17.4727L17.6045 16.1934ZM12 6.5C8.96243 6.5 6.5 8.96243 6.5 12C6.5 15.0376 8.96243 17.5 12 17.5C15.0376 17.5 17.5 15.0376 17.5 12C17.5 8.96243 15.0376 6.5 12 6.5ZM3.46973 7.81543C2.84918 9.07803 2.5 10.4981 2.5 12C2.5 13.5015 2.84942 14.9212 3.46973 16.1836L5.62988 14.9023C5.2263 14.018 5 13.0356 5 12C5 10.9638 5.22584 9.98048 5.62988 9.0957L3.46973 7.81543ZM18.3691 9.0957C18.7733 9.98058 19 10.9636 19 12C19 13.036 18.7731 14.0187 18.3691 14.9033L20.5293 16.1836C21.1497 14.9211 21.5 13.5017 21.5 12C21.5 10.498 21.15 9.07812 20.5293 7.81543L18.3691 9.0957ZM12 9C13.7809 9.77619 14.9997 11.2102 15 12.3496C15 13.1407 14.2976 13.7744 13.4307 13.7744C12.9179 13.7744 12.661 13.5417 12.375 13.1895C12.4162 13.52 12.375 13.1895 12.75 15H11.25C11.625 13.1896 11.5823 13.5192 11.625 13.1895C11.3398 13.5409 11.0831 13.7744 10.5674 13.7744C9.70146 13.7742 9.00021 13.1443 9 12.3535C9 11.1616 10.2737 9.77699 12 9ZM11.25 2.53125C8.35263 2.75758 5.82201 4.28304 4.2373 6.52637L6.39453 7.80566C7.53024 6.29029 9.2666 5.25132 11.25 5.04004V2.53125ZM12.75 5.04004C14.7332 5.25129 16.4688 6.29055 17.6045 7.80566L19.7617 6.52637C18.177 4.28329 15.6472 2.75757 12.75 2.53125V5.04004Z",
      fill: "white"
    }
  )
);

export { GamePoker };
//# sourceMappingURL=GamePoker.js.map
